import utils from "@/utils";
import filter from "@/utils/filter";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "intersection-observer";
import Vue from "vue";
import VueCookie from "vue-cookie";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import types from "./store/types";
import SentryConfig from './sentry';
import VConsole from 'vconsole';


const productionEnvironments = ['pro', 'uat'];
const isDevelopment = !productionEnvironments.includes(process.env.VUE_APP_ENV);
const isLocalhost = window.location.hostname === 'localhost';

if (isDevelopment || isLocalhost) {
  new VConsole();
}

Vue.use(ElementUI);
Vue.use(VueCookie);

Vue.config.productionTip = false;
Vue.filter("ossPath", filter.getOssPath);
Vue.filter("filterPrice", filter.filterPrice);
Vue.filter("floatPrice", filter.floatPrice);
router.beforeEach((to, from, next) => {
  let meta = to.meta;
  if (meta) {
    let { title, content, requireAuth } = meta;
    meta.title && (document.title = meta.title);
    if (requireAuth) {
      if (utils.isLogin()) {
        utils.setPageInfo(title, content);
        next();
      } else {
        next({
          name: "Login",
          query: {
            returnUrl: to.fullPath,
          },
        });
      }
    } else {
      utils.setPageInfo(title, content);
      next();
    }
  } else {
    utils.setPageInfo(null, null);
    next();
  }
});

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  if (window.gtag) {
    window.gtag("config", "UA-167964323-2", {
      page_path: to.fullPath,
    });
  }
  store.commit(types.PUSH_HISTORY, to.fullPath);
});

// sentry init
SentryConfig()

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
